import { fetcher } from 'utils/axios';
import {
  CreateSimpleTemplateParams,
  SimpleMessageTemplate,
  UpdateSimpleTemplateParams,
} from 'types/templates/simple-templates';

/**
 * Get all simple message templates for the current company
 */
export async function getSimpleTemplates() {
  try {
    const data = await fetcher('get', '/api/services/simpleTemplates/getList', 'newapi');
    if (data?.result) {
      return data.templates as SimpleMessageTemplate[];
    }
    return [];
  } catch (error) {
    console.error('getSimpleTemplates error:', error);
    return [];
  }
}

/**
 * Create a new simple template
 */
export async function createSimpleTemplate(params: CreateSimpleTemplateParams) {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/services/simpleTemplates/',
        {
          data: params,
        },
      ],
      'newapi',
    );
    return data as { result: boolean; template?: SimpleMessageTemplate; message?: string };
  } catch (error) {
    console.error('createSimpleTemplate error:', error);
    return { result: false, message: 'שגיאה ביצירת התבנית' };
  }
}

/**
 * Update an existing simple template
 */
export async function updateSimpleTemplate(params: UpdateSimpleTemplateParams) {
  try {
    const { id, ...updateData } = params;
    const data = await fetcher(
      'put',
      [
        `/api/services/simpleTemplates/${id}`,
        {
          data: updateData,
        },
      ],
      'newapi',
    );
    return data as { result: boolean; template?: SimpleMessageTemplate; message?: string };
  } catch (error) {
    console.error('updateSimpleTemplate error:', error);
    return { result: false, message: 'שגיאה בעדכון התבנית' };
  }
}

/**
 * Delete a simple template
 */
export async function deleteSimpleTemplate(id: string) {
  try {
    const data = await fetcher(
      'delete',
      `/api/services/simpleTemplates/${id}`,
      'newapi',
    );
    return data as { result: boolean; message?: string };
  } catch (error) {
    console.error('deleteSimpleTemplate error:', error);
    return { result: false, message: 'שגיאה במחיקת התבנית' };
  }
}

